import React from 'react';
import { useHistory } from 'react-router-dom';
import Flex from '@applied/dragonfruit/src/components/Layout/Flex';
import { Typography } from '@applied/dragonfruit/src/components/Text/Typography';
import { useQuery } from '@tanstack/react-query';

import { getIcon, WebOfferIcon } from 'components/WebOfferPage/icon_requests';

import './nda-section.scss';

export function NdaSection(): JSX.Element {
  const history = useHistory();
  const { data: ndaIconResponse } = useQuery({
    queryKey: ['icon', WebOfferIcon.CONFIDENTIAL],
    queryFn: () => getIcon(WebOfferIcon.CONFIDENTIAL, history),
  });

  return (
    <Flex
      className="nda-section"
      direction="row"
      gap="sm"
      alignment="center"
      justify="center"
      padding="md"
    >
      {ndaIconResponse?.iconUrl && (
        <img className="nda-icon" src={ndaIconResponse.iconUrl} alt="NDA" />
      )}
      <Typography className="nda-text" variant="body">
        <strong>Confidential:</strong> Shared with you under NDA.
      </Typography>
    </Flex>
  );
}
